let CalcTools = {
    appLocale: 'ru',

    distinct: function (value, index, self) {
        return self.indexOf(value) === index;
    },

    setupArraySortBy: function () {
        if (typeof Object.defineProperty === 'function') {
            /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
            try { Object.defineProperty(Array.prototype, 'sortBy', { value: sb }); } catch (e) { }
        }
        if (!Array.prototype.sortBy) Array.prototype.sortBy = sb;

        function sb(f) {
            for (var i = this.length; i;) {
                var o = this[--i];
                this[i] = [].concat(f.call(o, o, i), o);
            }
            this.sort(function (a, b) {
                for (var i = 0, len = a.length; i < len; ++i) {
                    if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
                }
                return 0;
            });
            for (var i = this.length; i;) {
                this[--i] = this[i][this[i].length - 1];
            }
            return this;
        }
    },

    /*
     * Split string to array (fully internal method)
     */
    strSplitToArr: function (string, length) {
        var chunks, len, pos;

        string = (string === null) ? "" : string;
        length = (length === null) ? 1 : length;

        chunks = [];
        pos = 0;
        len = string.length;
        while (pos < len) {
            chunks.push(string.slice(pos, pos += length));
        }

        return chunks;
    },

    /*
     * Chose morph ending (fully internal method)
     */
    morph: function (number, titles) {
        var cases = [2, 0, 1, 1, 1, 2];
        var number100rest = number % 100;
        return titles[(number100rest > 4 && number100rest < 20) ? 2 : cases[Math.min(number % 10, 5)]];
    },

    /*
     * Convert number to words string
     */
    verboseNumber: function (num) {
        var def_translite = {
            null: 'ноль',
            a1: ['один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'],
            a2: ['одна', 'две', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'],
            a10: ['десять', 'одиннадцать', 'двенадцать', 'тринадцать', 'четырнадцать', 'пятнадцать', 'шестнадцать', 'семнадцать', 'восемнадцать', 'девятнадцать'],
            a20: ['двадцать', 'тридцать', 'сорок', 'пятьдесят', 'шестьдесят', 'семьдесят', 'восемьдесят', 'девяносто'],
            a100: ['сто', 'двести', 'триста', 'четыреста', 'пятьсот', 'шестьсот', 'семьсот', 'восемьсот', 'девятьсот'],
            uc: ['копейка', 'копейки', 'копеек'],
            ur: ['рубль', 'рубля', 'рублей'],
            u6: ['тысяча', 'тысячи', 'тысяч'],
            u5: ['миллион', 'миллиона', 'миллионов'],
            u4: ['миллиард', 'миллиарда', 'миллиардов'],
            u3: ['триллион', 'триллиона', 'триллионов'],
            u2: ['квадриллион', 'квадриллиона', 'квадриллионов'],
            u1: ['квинтиллион', 'квинтиллиона', 'квинтиллионов'],
            k5: ['секстиллион', 'секстиллиона', 'секстиллионов'],
            k4: ['септиллион', 'септиллиона', 'септиллионов'],
            k3: ['октиллион', 'октиллиона', 'октиллионов'],
            k2: ['нониллион', 'нониллиона', 'нониллионов'],
            k1: ['дециллион', 'дециллиона', 'дециллионов'],
        };
        var i1, i2, i3, kop, out, rub, v, zeros, _ref, _ref1, _ref2, ax;

        _ref = parseFloat(num).toFixed(2).split('.'), rub = _ref[0], kop = _ref[1];
        var leading_zeros = 21 - rub.length;
        if (leading_zeros < 0) {
            return false;
        }

        zeros = [];
        while (leading_zeros--) {
            zeros.push('0');
        }
        rub = zeros.join('') + rub;
        out = [];
        if (rub > 0) {
            // Split by 3 symbols
            _ref1 = this.strSplitToArr(rub, 3);
            for (var i = -1; i < _ref1.length; i++) {
                v = _ref1[i];
                if (!(v > 0)) continue;
                _ref2 = this.strSplitToArr(v, 1), i1 = parseInt(_ref2[0]), i2 = parseInt(_ref2[1]), i3 = parseInt(_ref2[2]);
                out.push(def_translite.a100[i1 - 1]); // 1xx-9xx
                ax = (i + 1 === 6) ? 'a2' : 'a1';
                if (i2 > 1) {
                    out.push(def_translite.a20[i2 - 2] + (i3 > 0 ? ' ' + def_translite[ax][i3 - 1] : '')); // 20-99
                } else {
                    out.push(i2 > 0 ? def_translite.a10[i3] : def_translite[ax][i3 - 1]); // 10-19 | 1-9
                }

                if (_ref1.length > i + 1) {

                    var name = def_translite['u' + (i + 1)];
                    out.push(this.morph(v, name));
                }
            }
        } else {
            out.push(def_translite.null);
        }
        // "рубли"
        out.push(this.morph(rub, def_translite.ur));

        // "копейки"
        out.push(kop + ' ' + this.morph(kop, def_translite.uc));

        return out.join(' ').replace(RegExp(' {2,}', 'g'), ' ').trim();
    },


    /*
     *  It's important to use last symbol.
     *  Because for negative values we will get correct results.
     *      Using mod we will get negative values and must use additional check code.
     *  You can understand what to pass in verbosingTriplets using next rules:
     *      Every rule is a list of three strings, what you will write after number:
     *          1. 21 (день)
     *          2. 22 (дня)
     *          3. 27 (дней)
     */
    verboseCountingValue: function (intVal, verbosingTriplets) {
        var sVal = '' + parseInt(intVal);                 // '{}.format(int(v))
        var renderingValue = this.getLocaleNumber(intVal);     // '{:.2f}.format(v)
        var lastLetter = sVal[sVal.length - 1];
        var index = 2;

        if ('' + intVal !== sVal) {
            index = 1;
        }
        else if (sVal.length < 2 || sVal[sVal.length - 2] !== '1') {
            if (lastLetter === '1') {
                index = 0;
            }
            else if ((+lastLetter + 5) % 10 > 6) {
                index = 1;
            }
        }

        return renderingValue + ' ' + verbosingTriplets.map(function (triplet) { return triplet[index]; }).join(" ");
    },

    /*
     * Useful to make such strings like:
     *  > 12 years 3 monthes 9 days
     *  * If one of stack elements has zero value it will be ommited.
     *  
     * Bullet structure:
     *      - value
     *      - triplets
     */
    verboseStackOfCountingValues: function (bullets) {
        var result = [];
        let self = this;
        bullets.forEach(function (b) {
            if (b.value) {
                var triplets = b.triplets;
                if (typeof triplets[0] === "string")
                    triplets = [triplets];
                result.push(self.verboseCountingValue(b.value, triplets));
            }
        });
        return result.join(" ");
    },


    round10: function (value, digits) {
        var p = Math.pow(10, digits);
        return Math.round(value * p) / p;
    },

    /*
     * Function creates deep copy of an object.
     */
    deepcopy: function (obj, params) {
        const { exclude } = Object.assign({ exclude: [] }, params || {});
        var copy;

        function isElement(o) {
            return (
                typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
                    o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
            );
        }

        // Handle the 3 simple types, and null or undefined
        if (null === obj || "object" !== typeof obj || isElement(obj)) return obj;

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepcopy(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr) && exclude.indexOf(attr) < 0) {
                    copy[attr] = this.deepcopy(obj[attr]);
                }
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    },


    UTF8: {  // Useless. Remove?
        encode: function (s) {
            for (var c, i = -1, l = (s = s.split("")).length, o = String.fromCharCode; ++i < l;
                s[i] = (c = s[i].charCodeAt(0)) >= 127 ? o(0xc0 | (c >>> 6)) + o(0x80 | (c & 0x3f)) : s[i]
            );
            return s.join("");
        },
        decode: function (s) {
            for (var a, b, i = -1, l = (s = s.split("")).length, o = String.fromCharCode, c = "charCodeAt"; ++i < l;
                ((a = s[i][c](0)) & 0x80) &&
                (s[i] = (a & 0xfc) == 0xc0 && ((b = s[i + 1][c](0)) & 0xc0) == 0x80 ?
                    o(((a & 0x03) << 6) + (b & 0x3f)) : o(128), s[++i] = "")
            );
            return s.join("");
        }
    },


    getLocaleNumber: function (number, params) {
        params = params || {};
        var allowZero = (params.allowZero === undefined ? true : params.allowZero);
        var maxPrecision = params.maxPrecision || 2;
        var minPrecision = params.minPrecision;

        if (!number && (number !== 0 || !allowZero)) {
            return '';
        }

        var formatParams = {
            maximumFractionDigits: maxPrecision
        };

        if (minPrecision !== undefined)
            formatParams.minimumFractionDigits = minPrecision;

        return number.toLocaleString(this.appLocale, formatParams);
    },


    getRoundedNumber: function (number) {
        if (!number) {
            return 0;
        }

        return Math.round(number);
    },

    getLocaleSum: function (sum) {
        sum = sum !== null ? sum : 0;
        return this.getLocaleNumber(sum, { minPrecision: 2 });
    },

    getRoundedNumberInRubbles: function (number) {
        return this.getLocaleNumber(this.getRoundedNumber(number)) + '&nbsp;' + this.getRubble();
    },

    getLocaleSumInRubbles: function (sum) {
        return this.getLocaleSum(sum) + '&nbsp;' + this.getRubble();
    },

    getRubble: function () {
        if (!this.getRubble.hasOwnProperty('charValue')) {
            this.getRubble.charValue = $('#rubbleChar').html();
        }
        return this.getRubble.charValue;
    },

    parseLocaleFloat: function (num) {
        var val = parseFloat(num.replace(/[^\d\.,\/юб]/g, '').replace(/[,\/юб]/g, '\.'));
        return val ? val : 0;
    },

    parseLocaleInt: function (num) {
        var val = parseInt(num.replace(/[^\d,\.]/g, '').replace(/,/g, '\.'));
        return val ? val : 0;
    },

    escapeTags: function (str) {
        // this is deprecated, use lib/utils/utils
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },

    unescapeTags: function (str) {
        // this is deprecated, use lib/utils/utils
        return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    },

    removeExtraSpace: function(str){
        return str.replace(/ +/g, ' ').trim();
    },

    // Initialize <a> links with baseurl and set last=1 if needed
    // Use 'permalink' class to avoid last=1 param
    initSmartLink: function (link, last) {
        last = last === undefined ? true : last;
        var $link = $(link);
        var querystring = $link.data('link');

        if (IsOffline) {
            $link.attr('target', '_self');
            querystring = querystring.replace('req=doc&', '').replace(/&/g, ';');
        } else {
            $link.attr('target', '_blank');
        }
        
        $link.attr('href', BaseUrl + querystring + (last && !$link.hasClass('permalink') ? LastParam : '') + (!IsAuthEnabled ? DemoParam : ''));

        // using attr('onclick', ...) instead of .click(function () {...}) to support link html copying in some calculators
        $link.attr('onclick', 'ym(' + ymId + ', "' + ymReachGoal + '", "calc_UL");ym(' + ymbId + ', "' + ymReachGoal + '", "calc_UL");return true;');
    },
    transformSmartLinks(text) {
        debugger;
        const linkRegex = /<a\s+[^>]*data-link\s*=\s*["']([^"']+)["'][^>]*>/gi;
        
        return text.replace(linkRegex, (match, querystring) => {
            try {
                const hasPermalinkClass = /class\s*=\s*["'][^"']*permalink[^"']*["']/i.test(match);
                let newUrl = ExportBaseUrl + querystring + (!hasPermalinkClass ? ExportLastParam : '') + (!IsAuthEnabled ? DemoParam : '');
                const hrefRegex = /href\s*=\s*["'][^"']*["']/i;
                if (hrefRegex.test(match)) {
                    return match.replace(hrefRegex, `href="${newUrl}"`);
                } else {
                    return match.replace('<a ', `<a href="${newUrl}" `);
                }
            } catch (error) {
                return match;
            }
        });
    },
    setWarningMessage: function (promoblock) {
        var $promoblock = $(promoblock);
        var $warningmsg = $('<div class="warning-msg">Расчет носит справочный характер и не может быть основанием для совершения юридически значимых действий.</div>');
        $promoblock.append($warningmsg.clone()[0]);
        $warningmsg.addClass('only-print');
        $('.top-panel').prepend($warningmsg);
    },

    selectAllText: function () {
        var input = this;
        // setTimeout - fix for EDGE browser
        window.setTimeout(function () {
            input.select();
        }, 1);
    },

    // Math.round is incorrect for 1.015  (Math.round(1.015 * 100) / 100) === 1.01)
    roundNumber: function (num, scale, roundFunc) {
        if (!roundFunc) {
            roundFunc = Math.round;
        }
        const log10 = (num) => Math.log(num) / Math.log(10);
        if (("" + num).indexOf("e") < 0) {
            if (Math.abs(num) > 1 && log10(Math.abs(num)) + scale > 21)
                return num;
            return +(roundFunc(num + "e+" + scale) + "e-" + scale);
        } else {
            var arr = ("" + num).split("e");
            var sig = "";
            if (+arr[1] + scale > 0) {
                sig = "+";
            }
            return +(roundFunc(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
        }
    },

    convertElemToTextWithLinksForExport: function (elem, last) {
        last = last === undefined ? true : last;
        var clone = $(elem).clone()[0];
        const ignoreElems = clone.getElementsByClassName('ignore_export');
        for (let i = ignoreElems.length - 1; i >= 0; --i) {
            ignoreElems[i].outerHTML = '';
        }
        var uls = clone.getElementsByTagName('ul');
        for (var i = uls.length - 1; i >= 0; --i) {
            var ul = $(uls[i]);
            var lis = ul[0].getElementsByTagName('li');
            for (var j = lis.length - 1; j >= 0; --j) {
                var li = $(lis[j]);
                li[0].outerHTML = "#" + li.html();
            }
            ul[0].outerHTML = ul.html();
        }
        var links = clone.getElementsByTagName('a');
        for (var i = links.length - 1; i >= 0; --i) {
            var link = $(links[i]);
            link[0].outerHTML = "{" + link.data('link') + (last && !link.hasClass('permalink') ? ExportLastParam : '') + (!IsAuthEnabled ? DemoParam : '') + "|" + link.text() + "}";
        }
        var brakes = clone.getElementsByTagName('br');
        for (var i = brakes.length - 1; i >= 0; --i) {
            var brake = $(brakes[i]);
            brake[0].outerHTML = "|";
        }
        return $(clone).text().replace(/\s\s+/g, ' ');
    },

    /*
     *  Checks that all requiredAttributes in params and returns true if everything is good.
     */
    checkParams: function (params, requiredAttributes, verbose) {
        verbose = (verbose === undefined ? true : verbose);
        for (var i = 0; i < requiredAttributes.length; ++i) {
            var attr = requiredAttributes[i];
            if (!params.hasOwnProperty(attr)) {
                if (verbose)
                    console.error("Not all required attributes in params: " + attr);
                return false;
            }
        }
        return true;
    },

    parseSelect: function (elem) {
        return {
            value: elem.value,
            text: (elem.selectedIndex < 0 ? null : elem.options[elem.selectedIndex].text)
        };
    },



    /*
     * selector - jQuery element selector
     * params.showFilter: true - show filter, otherwise - hide 
     * params.palceholder: filter input placeholder
     * params.list: js list of elements (required when no select)
     * params.val_member: params.list item value member name (list[i].val_member)
     * params.text_member: params.list item text member name (list[i].text_member)
     * params.defaultValue: first params.list item having this value will be selected by default
     * 
     * Examples
     * 1) Dropdown filled in js
     * html:    <div id="ddTest1" class="ddc">
     *              <div class="button"><div>Федеральный округ или субъект</div></div>
     *          </div>
     * js:      tools.generateDropDown("#ddTest1", { showFilter: true, list: districts_subjects, val_member: 'districtid', text_member: 'name' });
     * 
     * 2) Dropdown filled in html
     * html:    <div id="ddTest2" class="ddc">
     *              <div class="button"><div>Причина увольнения</div></div>
     *              <select>
     *                 <option value="own_wish">Увольнение по собственному желанию</option>
     *                 <option value="both_sides">Увольнение по соглашению сторон</option>
     *                 <option value="rif">Сокращение штата</option>
     *             </select>
     *          </div>
     * js:      tools.generateDropDown("#ddTest2");
     *              or add .select class to #ddTest2 div to auto generate dropdown
     * 
     * 3) Autogenerated dropdown from select
     * html:    <select class="ddc">
     *              <option value="own_wish">Увольнение по собственному желанию</option>
     *              <option value="both_sides">Увольнение по соглашению сторон</option>
     *              <option value="rif">Сокращение штата</option>
     *          </select>
     *
     * It's possible to use native select operations like value, selectedIndex, options. 
     * Alternative methods:
     * getDropDownSelectedItem("#ddTest1") will return selected html elem
     * getDropDownSelectedItemValue("#ddTest1") / getDropDownSelectedItemText("#ddTest1") will return selected value / text
     * 
     * var value = getDropDownSelectedItemValue("#ddTest1");
     * if (value) console.log(value);
     *
     * var text = getDropDownSelectedItemText("#ddTest1");
     * if (text) console.log(text);
    */
    generateDropDown: function (selector, params) {
        let self = this;
        params = params || {};
        if (params.list && params.list.length === 0) {
            return;
        }

        var showFilter = typeof params.showFilter === 'boolean' ? params.showFilter : false;
        var filterPlaceholder = params.palceholder || 'Фильтр';

        var $elem = $(selector);

        $elem.find('.ddc-droplist').remove(); // remove old droplist

        var $elemButton = $elem.find(".button");
        $elemButton.attr('tabindex', '0');
        var $dropfilter = $('<div class="ddc-dropfilter"><input class="base-input" placeholder="' + filterPlaceholder + '" autocomplete="off"/><div class="ddc-nothingfound">ничего не найдено</div></div>');
        var $dropelems = $('<div class="ddc-dropelems"></div>');
        var filterClassName = showFilter ? ' ddc-droplist-with-filter' : '';
        var $droplist = $('<div class="ddc-droplist' + filterClassName + '"></div>');
        if ($elem.width() > 0) {
            $elemButton.css('width', $elem.width() + 'px');
        }

        var $elemButtonText = $elemButton.find("div");
        $elemButtonText.text($elemButtonText.text().replace(/^\s+|\s+$/g, ''));
        if ($elemButtonText.text() === "") {
            $elem.addClass("selected");
        }

        if (params.list) {
            for (var i = 0; i < params.list.length; i++) {
                $dropelems.append($('<div class="ddc-dropelem" data-value="' + params.list[i][params.val_member] + '">' + params.list[i][params.text_member] + '</div>'));
            }
        } else {
            var $select = $elem.find("select");
            var placeholder = null;
            var selected = null;
            if ($select.length > 0) {
                $select.find('option').each(function () {
                    var $option = $(this);
                    if (this.getAttribute('disabled') !== null) {
                        placeholder = $option.text();
                        return;
                    }
                    else if (this.getAttribute('selected') !== null) {
                        selected = $option.val();
                        $elem.addClass("selected");
                    }
                    $dropelems.append($('<div class="ddc-dropelem" data-value="' + $option.val() + '">' + $option.text() + '</div>'));
                });
                $select.remove();
            }
            if ($elemButtonText.text() === '' && placeholder !== null) {
                $elemButtonText.text(placeholder);
            }
            if (selected !== null && !params.defaultValue) {
                params.defaultValue = selected;
                $elem.addClass("selected");
            }
        }

        if (!$elemButton.data('placeholder')) {
            $elemButton.data('placeholder', $elemButtonText.text()); // store default dropdown placeholder (first making)
        }

        if (showFilter) {
            $droplist.append($dropfilter);
        }

        if ($elemButtonText.text() === '' && !params.defaultValue) {
            params.defaultValue = $dropelems.find(".ddc-dropelem").data('value');
        }

        if (params.defaultValue === '' || params.defaultValue) {
            var $itemToSelect = $dropelems.find(".ddc-dropelem[data-value='" + params.defaultValue + "']");
            if ($itemToSelect.length > 0) {
                $itemToSelect = $itemToSelect.eq(0); // to prevent multiselection
                $itemToSelect.addClass('selected hl');
                $elemButtonText.text($itemToSelect.text());
            }
        }

        $droplist.append($dropelems);
        $elem.append($droplist);

        var visibleElemSelector = '.ddc-dropelem:not(.hidden-control)';

        $elemButton.unbind(); // unbind old events
        $elemButton.click(function (e) {
            //e.preventDefault();
            //e.stopPropagation();

            if ($elem.hasClass("expanded")) {
                $elem.removeClass("expanded");
                return;
            }
            var dropdownTop = $elemButton.offset().top;
            var dropdownBottom = dropdownTop + $droplist.outerHeight() + $elemButton.height();
            var windowTop = $(window).scrollTop();
            var windowBottom = windowTop + $(window).height();
            if (windowTop > dropdownTop) {
                $(window).scrollTop(dropdownTop);
            } else if (windowBottom < dropdownBottom) {
                $(window).scrollTop(windowTop + Math.min(dropdownBottom - windowBottom, dropdownTop - windowTop));
            }
            $droplist.css('width', $elemButton.css('width'));
            $elem.addClass("expanded");
            $elem.focusin();
            var $selectedItem = $dropelems.find(".selected");
            if ($selectedItem.length > 0) {
                $dropelems.find(".hl").removeClass('hl');
                $selectedItem.addClass('hl');
            } else if ($droplist.find('.ddc-dropelem.hl').length === 0) {
                $droplist.find(visibleElemSelector).first().addClass('hl');
                $dropelems.scrollTop(0);
            }
            if (showFilter) {
                $dropfilter.find('input').focus();
            }
        });

        $elemButton.keydown(function (e) {
            if (!$elem.hasClass("expanded")) {
                if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40) { // enter or space or arrows
                    e.preventDefault();
                    e.stopPropagation();
                    this.click();
                }
            }
        });

        var $filterDropElems = $droplist.find('.ddc-dropelem');

        if (showFilter) {
            $dropfilter.change(function (e) { e.stopPropagation(); });
            $dropfilter.find('input').keyup(function (e) {
                var filterText = $(this).val();

                if (this.hasOwnProperty("oldFilter") && this.oldFilter === filterText || e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 33 || e.keyCode === 34 || e.keyCode === 13 || e.keyCode === 27) { // 38, 48: up, down
                    return;
                }
                this.oldFilter = filterText;

                var searchRegex = new RegExp('(?:^|\\s|-|\\s\\W)(' + filterText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
                $droplist.find('.ddc-dropelem.hl').removeClass('hl');
                $filterDropElems.each(function () {
                    var $item = $(this);
                    var elemVal = $item.text();
                    if (filterText && filterText.trim() && !elemVal.match(searchRegex)) {
                        $item.addClass('hidden-control');
                    } else {
                        $item.removeClass('hidden-control');
                    }
                });
                var visibleElems = $droplist.find(visibleElemSelector);
                if (visibleElems.length > 0) {
                    visibleElems.eq(0).addClass('hl');
                    $droplist.removeClass('nf');
                } else {
                    $droplist.addClass('nf');
                }
            });
        }

        function selectElem(elem) {
            if (elem === null) {
                $elemButtonText.html($elemButton.data('placeholder'));
            } else {
                $elem.removeClass('expanded');
                $elem.addClass('selected');
                var $selectedElem = $(elem);
                if (!$selectedElem.hasClass('selected')) {
                    $elemButtonText.text($selectedElem.text());
                    $dropelems.find("div.selected, div.hl").removeClass('selected hl');
                    $selectedElem.addClass('selected hl');
                    $elem.change();
                }
            }
        }

        $filterDropElems.click(function () {
            selectElem(this);
            $elemButton.focus();
        });

        $filterDropElems.hover(function () { // js .ddc-dropelem:hover implementation
            $dropelems.find(".hl").removeClass('hl');
            $(this).addClass('hl');
        });

        $filterDropElems.mousemove(function () { // reset hl class ot item under mouse pointer after moving hl by keys
            if (!this.classList.contains("hl")) {
                $dropelems.find(".hl").removeClass('hl');
                this.classList.add('hl');
            }
        });

        $(document).mousedown(function (e) {
            if ($droplist.parent().hasClass("expanded")) { // $droplist.parent() instead of $elem - fix to prevent handling after reinitialization (second generateDropDown call)
                if (!$elemButton.is(e.target) && !$elemButtonText.is(e.target) && !$droplist.is(e.target) && $droplist.has(e.target).length === 0) {
                    $elem.removeClass("expanded");
                }
            }
        });

        $(window).keydown(function (e) {
            if ($droplist.parent().hasClass("expanded")) { // $droplist.parent() - fix to prevent handling after reinitialization (second generateDropDown call)
                if (e.keyCode === 27 || e.keyCode === 9) { // escape or tab
                    e.preventDefault();
                    $elem.removeClass("expanded");
                    $elemButton.focus();
                }

                if (e.keyCode === 13) { // enter
                    e.preventDefault();
                    $droplist.find('.ddc-dropelem.hl').first().click();
                }

                if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 33 || e.keyCode === 34) { // up, down, pageup, pagedown
                    e.preventDefault();

                    var $selectedElem = $droplist.find('.ddc-dropelem.hl');
                    if ($selectedElem.length > 0) {
                        var $selectedElemNew;
                        if (e.which === 38) { // up
                            $selectedElemNew = $selectedElem.prevAll(visibleElemSelector).first();
                        } else if (e.which === 40) { // down
                            $selectedElemNew = $selectedElem.nextAll(visibleElemSelector).first();
                        } else if (e.which === 33 || e.which === 34) { // pageup, pagedown
                            var elemsPerPage = parseInt($dropelems.height() / $selectedElem.outerHeight(), 10);
                            var $elems = e.which === 33 ? $selectedElem.prevAll(visibleElemSelector) : $selectedElem.nextAll(visibleElemSelector);
                            if ($elems.length > elemsPerPage) {
                                $selectedElemNew = $elems.eq(elemsPerPage);
                            } else {
                                $selectedElemNew = $elems.last();
                            }
                        }

                        if ($selectedElemNew.length > 0) {
                            $selectedElem.removeClass('hl');
                            $selectedElemNew.addClass('hl');

                            var selectedElemPos = $selectedElemNew.offset().top - $dropelems.offset().top;
                            var selectedElemPosMax = $dropelems.height() - $selectedElemNew.outerHeight();
                            if (selectedElemPos < 0) {
                                $dropelems.scrollTop($dropelems.scrollTop() + selectedElemPos);
                            } else if (selectedElemPos > selectedElemPosMax) {
                                $dropelems.scrollTop($dropelems.scrollTop() + selectedElemPos - selectedElemPosMax);
                            }
                        }

                    } else {
                        $droplist.find(visibleElemSelector).first().addClass('hl');
                    }

                }
            }
        });

        // make behavior like in usual select
        Object.defineProperty($elem[0], 'value', {
            get: function () { return $elem.find('.ddc-dropelems .ddc-dropelem.selected').data('value') || ''; },
            set: function (v) { self.setDropDownValue(selector, v); },
            configurable: true
        });

        Object.defineProperty($elem[0], 'selectedIndex', {
            get: function () { return Array.prototype.indexOf.call($dropelems.find('.ddc-dropelem'), $dropelems.find('.ddc-dropelem.selected')[0]); },
            set: function (v) { self.setDropDownValue(selector, $dropelems.find('.ddc-dropelem').toArray()[v].getAttribute('data-value')); },
            configurable: true
        });

        Object.defineProperty($elem[0], 'options', {
            get: function () {
                return $dropelems.find('.ddc-dropelem').toArray().map(function (opt) {
                    return { value: opt.getAttribute('data-value'), text: $(opt).text() };
                });
            },
            set: function (v) { console.error('Setter is not implemented'); },
            configurable: true
        });

        $elem[0].selectItem = selectElem;
    },

    getDropDownSelectedItem: function (selector) {
        return $(selector).find('.ddc-dropelems .ddc-dropelem.selected');
    },

    getDropDownSelectedItemValue: function (selector) {
        return this.getDropDownSelectedItem(selector).data('value');
    },

    getDropDownSelectedItemText: function (selector) {
        return this.getDropDownSelectedItem(selector).text();
    },

    /*
        * Set dropdown value programmatically. First .ddc-dropelem[data-value='" + val + "'] will be selected
    */
    setDropDownValue: function (selector, val) {
        var $elem = $(selector);
        var $dropelems = $elem.find('.ddc-dropelems');
        if (!($dropelems.length === 0)) {
            $dropelems.find(".ddc-dropelem").removeClass('selected hl hidden-control');

            var $droplist = $elem.find('.ddc-droplist');
            $droplist.removeClass('nf');
            $droplist.find('.ddc-dropfilter input').val('');

            if (val !== null) {
                var $itemToSelect = $dropelems.find(".ddc-dropelem[data-value='" + val + "']");
                if ($itemToSelect.length > 0) {
                    $itemToSelect = $itemToSelect.eq(0); // to prevent multiselection
                    $elem[0].selectItem($itemToSelect[0]);
                    return;
                }
            }
            $elem.removeClass("selected");
            $elem[0].selectItem(null);
        }
    },

    /*
        * Reset dropdown and unselect items
    */
    resetDropDown: function (selector) {
        this.setDropDownValue(selector, null);
    },

    transformSelect: function (select) {
        var $select = $(select).clone();
        var _select = $select[0];
        var parent = select.parentNode;
        var index = Array.prototype.indexOf.call(parent.childNodes, select);
        var mainDiv = document.createElement('div');

        mainDiv.id = _select.id;
        mainDiv.className = _select.className;
        mainDiv.classList.add('ddc');
        mainDiv.classList.add('select');
        mainDiv.innerHTML = '<div class="button"><div></div></div>';
        mainDiv.appendChild(_select);
        select.outerHTML = mainDiv.outerHTML;
        this.generateDropDown(parent.childNodes[index]);
    },

    /**
     * Works like jqueryNode.find(selector) but excludes all elements which inside other selected element.
     * @param {any} jqueryNode - node where we will search
     * @param {any} selector - selector to find inside the node
     */
    findExternalOnly: function (jqueryNode, selector) {
        let elements = jqueryNode.find(`${selector.trim()}`).map((index, elem) =>{
            return {elem, isActive: true};
        });

        for(let i=0; i < elements.length; i++)
            for(let j = 0; j < elements.length; j++)
                if(i!=j && elements[i].elem.compareDocumentPosition(elements[j].elem) == 10)// read https://learn.javascript.ru/compare-document-position
                    elements[i].isActive = false;

        return elements.filter((index, item) => item.isActive).map((index, item) => item.elem);
    }
};

export { CalcTools };